module.exports = __webpack_public_path__ + "ui-static/img/external-vms-no-items_dark.60a66b00.svg";